const S3_BASE_URL = "https://s3service.sconexsoft.com/s3bucket/presigned-url";
const S3_BUCKET = "imageinsightimagesbeverages";

const urlCache = new Map();

const CACHE_TTL = 55 * 60 * 1000; 

export async function generatePresignedUrl(s3Path, { month, year } = {}) {
  const cacheKey = `${s3Path}_${month ?? ""}_${year ?? ""}`;

  const cached = urlCache.get(cacheKey);

  if (cached && Date.now() < cached.expiresAt) {
    return cached.url;
  }

  const params = new URLSearchParams({
    fileName: s3Path,
    bucketName: S3_BUCKET,
    operation: "download",
  });

  if (month != null) params.set("month", month);
  if (year != null) params.set("year", year);

  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);

    const response = await fetch(`${S3_BASE_URL}?${params}`, {
      signal: controller.signal,
    });

    clearTimeout(timeout);

    if (!response.ok) throw new Error("Failed to fetch presigned URL");

    const url = (await response.text()).trim();

    urlCache.set(cacheKey, {
      url,
      expiresAt: Date.now() + CACHE_TTL,
    });

    return url;
  } catch (err) {
    console.error("Failed to generate presigned URL:", err);
    return null;
  }
}

export function clearPresignedUrlCache() {
  urlCache.clear();
}